import React, { useState, useContext, useEffect } from 'react'
import './wallet.css'
import {
    handleRedirectInternal,
    mapData,
    jsonToFormData,
    currencyFormat,
} from '../../Product/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import PrimaryButton from '../../Product/components/atoms/PrimaryButton'
import AuthContext from '../../Product/context/auth/authContext'
import AlertContext from '../../Product/context/alert/alertContext'
import ProductContext from '../../Product/context/product/productContext'
import PluginContext from '../../Product/context/plugin/pluginContext'
import NoRecordsFound from '../../Product/components/atoms/NoRecordsFound'
import Loader from '../../assets/loader'
import moment from 'moment'
import { setRef } from '@material-ui/core'
import { Pagination } from '@material-ui/lab'
import Copy from '../../utils/CommonFunctionality/Share/Copy'

const WalletHistory = (props) => {
    const authContext = useContext(AuthContext)
    const productContext = useContext(ProductContext)
    const pluginContext = useContext(PluginContext)
    const validationArray = Yup.object({})
    const [regBtnLoading, setRegBtnLoading] = useState(false)
    const [listLoading, setListLoading] = useState(false)
    const [referralist, setReferralList] = useState([])
    const [walletAmount, setWalletAmount] = useState(0)
    const [referralListCount, setReferralListCount] = useState(0)
    const [page, setPage] = useState(1)

    const { user, loadUser, isAuthenticated, active_plugins, getActivePlugins } = authContext
    const { getReferralHistory, responseStatus, all_referrals, clearResponse } = pluginContext
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext

    useEffect(() => {
        if (responseStatus && responseStatus !== '') {
            if (responseStatus.from === 'getReferralHistory') {
                // redeemEnablelist({
                //     site_id: global?.storeDetails?.site_id,
                //     user_id: user.id,
                // })
                setListLoading(false)
            }
        }
    }, [responseStatus])
    useEffect(() => {
        if (all_referrals?.message && all_referrals?.message?.results.length > 0) {
            setReferralList(all_referrals?.message?.results)
            setReferralListCount(all_referrals?.message?.results_cnt)
            setWalletAmount(all_referrals?.message?.wallet_amount)
            setListLoading(false)
        } else {
            setReferralList([])
            setReferralListCount(0)
            setListLoading(false)
            setRegBtnLoading(false)
        }
    }, [all_referrals])
    useEffect(() => {
        setListLoading(true)
        const fetchReferralList = async () => {
            if (user) {
                const res = await getReferralHistory({
                    site_id: global?.storeDetails?.site_id,
                    user_id: user.id,
                    invoice_id: '',
                    type: 'wallet',
                    page: page,
                    perlimit: 10,
                })
            }
        }
        fetchReferralList()
    }, [user, page])

    return (
        <div>
            {listLoading ? (
                <div className="text-center">
                    <Loader />
                </div>
            ) : referralist.length > 0 ? (
                <>
                    <div>
                        {props.isGgtheme ? 'Credits Available' : 'props.isGgtheme'} :{' '}
                        {currencyFormat(walletAmount > 0 ? walletAmount : 0)}
                    </div>
                    <div className="table-responsive mt-4">
                        {
                            <table className="table table-hover mobile-table responisveTable">
                                <thead className="hidden-mobile">
                                    <tr>
                                        {/* <th></th> */}
                                        {/* <th className="numCell" role="id">
                                        Id
                                    </th> */}
                                        <th role="Plan">S.no</th>
                                        <th role="Amount">Name</th>
                                        {props.isGgtheme ? '' : <th role="Status">Type</th>}
                                        <th role="Status">Description</th>
                                        <th role="Status">
                                            {props.isGgtheme ? 'Reason Type' : 'Reason'}
                                        </th>
                                        <th role="Amount">Date</th>
                                        <th role="Status">Amount</th>
                                        <th role="Amount">Transaction ID</th>
                                        {/* <th role="RedeemDate">Redeem Date</th> */}
                                    </tr>
                                </thead>

                                <tbody>
                                    {referralist.length !== 0 &&
                                        referralist.map((item, index) => {
                                            return (
                                                <>
                                                    {item ? (
                                                        <tr key={index}>
                                                            {/* <td data-label="id">{item.id}</td> */}
                                                            <td
                                                                data-label="S.no"
                                                                className="center"
                                                            >
                                                                {index + 1}
                                                            </td>
                                                            <td
                                                                data-label="Name"
                                                                className="center"
                                                            >
                                                                {item?.name}
                                                            </td>
                                                            {props.isGgtheme ? (
                                                                ''
                                                            ) : (
                                                                <td
                                                                    data-label="Type"
                                                                    className="center"
                                                                >
                                                                    <span
                                                                        className={
                                                                            item?.credit_notes ==
                                                                            'remove'
                                                                                ? 'text-danger'
                                                                                : 'text-success'
                                                                        }
                                                                    >
                                                                        {item?.credit_notes ==
                                                                        'remove'
                                                                            ? 'Debit'
                                                                            : 'Credit'}
                                                                    </span>
                                                                </td>
                                                            )}
                                                            <td
                                                                data-label="Description"
                                                                className="center"
                                                            >
                                                                {item?.processing_option == 'refund'
                                                                    ? item.credit_notes
                                                                          .charAt(0)
                                                                          .toUpperCase() +
                                                                      item.credit_notes
                                                                          .slice(1)
                                                                          .toLowerCase()
                                                                    : item?.level_name !== '' &&
                                                                      item?.level_name != 0
                                                                    ? item.level_name
                                                                          .charAt(0)
                                                                          .toUpperCase() +
                                                                      item.level_name
                                                                          .slice(1)
                                                                          .toLowerCase()
                                                                    : '-'}
                                                            </td>
                                                            <td
                                                                data-label="Reason Type"
                                                                className="center"
                                                            >
                                                                {item?.reason !== ''
                                                                    ? item.reason
                                                                          .charAt(0)
                                                                          .toUpperCase() +
                                                                      item.reason
                                                                          .slice(1)
                                                                          .toLowerCase()
                                                                    : item?.credit_notes == 'remove'
                                                                    ? 'Item purchased on checkout'
                                                                    : 'Received'}
                                                            </td>

                                                            <td
                                                                data-label="Date"
                                                                className="center"
                                                            >
                                                                {moment
                                                                    .utc(
                                                                        item?.date_add,
                                                                        'MM/DD/YYYY hh:mm:ss A',
                                                                    )
                                                                    .local()
                                                                    .format('dddd, MMMM DD, YYYY')}
                                                            </td>
                                                            <td
                                                                data-label="amount"
                                                                className="center"
                                                            >
                                                                <span
                                                                    className={
                                                                        item?.credit_notes ==
                                                                        'remove'
                                                                            ? 'text-danger'
                                                                            : 'text-success'
                                                                    }
                                                                >
                                                                    {item?.credit_notes == 'remove'
                                                                        ? '-'
                                                                        : '+'}

                                                                    {currencyFormat(item?.amount)}
                                                                </span>
                                                            </td>
                                                            {/* <td
                                                                data-label="referral-notes"
                                                                className="center"
                                                            >
                                                                {item?.processing_option ==
                                                                'wallet_spent'
                                                                    ? 'Wallet Spent'
                                                                    : 'Wallet Added'}
                                                            </td> */}
                                                            <td
                                                                data-label="transaction-Id"
                                                                className="center"
                                                            >
                                                                {item?.processing_option ==
                                                                'wallet_spent'
                                                                    ? item?.transaction_id
                                                                    : '-'}
                                                            </td>
                                                        </tr>
                                                    ) : null}
                                                </>
                                            )
                                        })}
                                </tbody>
                            </table>
                        }
                    </div>
                    <Pagination
                        count={Math.ceil(referralListCount / 10)}
                        page={page}
                        onChange={(e, value) => setPage(value)}
                    />
                </>
            ) : (
                <NoRecordsFound />
            )}
        </div>
    )
}

export default WalletHistory
